import api from "../lib/axios";

// fetch sponsor data
export const getSponsorData = async (eventId) => {
  const res = await api.get(`/sponsor/getSponsors?event_id=${eventId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  const status = res.status;
  const data = res.data?.data?.sponsors || [];
  return { status, data };
};

export const updateSponsorPositionForEvent = async (eventId, token, data) => {
  const res = await api.put(
    `/sponsor/position/${eventId}`,
    { data },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const deleteSponsor = async (sponsorId, token) => {
  const res = await api.delete(`/sponsor/deleteSponsor/${sponsorId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

export const deleteSponsorTeam = async (data, id, token) => {
  const res = await api.post(
    `/sponsor/deleteSponsorTeam`,
    { data, id },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const getSponsors = async (eventId, token) => {
  const res = await api.get(`/sponsor/getSponsors?event_id=${eventId}`, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return res;
};

export const deleteSponsor2 = async (sponsorId, reason, token) => {
  const res = await api.delete(`/sponsor/deleteSponsor/${sponsorId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: { delete_reason: reason },
  });
  return res;
};

export const updateSponsor = async (sponsorId, formData, token) => {
  const res = await api.put(`/sponsor/updateSponsor/${sponsorId}`, formData, {
    headers: { Authorization: `Bearer ${token}` },
    transformRequest: [(d) => d],
  });
  return res;
};

export const updateSponsorTeam = async (member, token) => {
  const res = await api.put(`/sponsor/updateSponsorTeam`, member, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const createSponsors = async (formData, token) => {
  const res = await api.post(`/sponsor/createSponsors`, formData, {
    headers: { Authorization: `Bearer ${token}` },
    transformRequest: [(d) => d],
  });
  return res;
};
